import { render, staticRenderFns } from "./TS10.vue?vue&type=template&id=2cd6648a&"
import script from "./TS10.vue?vue&type=script&lang=js&"
export * from "./TS10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports